import React from 'react'
import { Routes, Route, Link } from 'react-router-dom';
import Placement_2020 from '../2020/Placement_2020'
import Placement_2021 from '../2021/Placement_2021'
import Placement_2022 from '../2022/Placement_2022'
import Placement_2023 from '../2023/Placement_2023'
import place_data_2022 from '../2022/Placement_data_2022'
import place_data_2020 from '../2020/Placement_data_2020';
import placedata2021 from '../2021/Placement_data_2021';
import place_data_2023 from '../2023/Placement_data_2023';

const Placement = () => {
  return (
<div>
 <div className='myheader'>
    <button className='merabtn'>
<span>Placements</span><i></i>
</button>
    </div>

   


    <div> 
    <div className='myclass'>
        
            <Link to="/place/2023">
                <div className='menuLink'>
                2023
                </div>
            </Link>

            <Link to="/place/2022">
                <div className='menuLink'>
                    2022
                </div>               
            </Link>

            <Link to="/place/2021"> 
              <div className='menuLink'>
                2021
              </div>
            </Link>

            <Link to="/place/2020"> 
              <div className='menuLink'>
                2020
              </div>
            </Link>


    </div> 
  
  
  <Routes>
  
    <Route exact path="2023" element={<Placement_2023 data={place_data_2023} />} />
    <Route exact path="2022" element={<Placement_2022 data= {place_data_2022} />} />
    <Route exact path="2021" element={<Placement_2021 data = {placedata2021} />} />
    <Route exact path="2020" element={<Placement_2020 data={place_data_2020} />} />
 

  </Routes>
 
 
  </div>

</div>
  )
}

export default Placement